type AccommodationSessionRecord = NonNullable<App.CheckoutState['accommodationSessions'][string]>

const NEAR_EXPIRY_MS = 5 * 60 * 1000

/**
 * Whether an enquiry session expires within five minutes, or has no known expiry. svc-accommodation
 * keeps `expiresAt` when it rewrites a session, so re-enquiring cannot extend it.
 */
export function isAccommodationV2SessionNearExpiry(record: AccommodationSessionRecord): boolean {
  if (!record.data?.expiresAt) return true
  return Date.parse(record.data.expiresAt) - Date.now() <= NEAR_EXPIRY_MS
}
